export default __webpack_public_path__ + "static/media/cyber-security-service.6e430d0a.png";